import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button-toggle-paper-bookmark',
  templateUrl: './button-toggle-paper-bookmark.component.html',
  styleUrls: ['./button-toggle-paper-bookmark.component.scss']
})
export class ButtonTogglePaperBookmarkComponent implements OnInit {
  constructor() {}

  @Input() isPaperBookmarked = false;
  @Input() disabled = false;
  @Input() canSpinner = false;
  @Output() bookmarkClick = new EventEmitter();

  showSpinner = false;

  ngOnInit() {}

  toggle() {
    if (this.canSpinner) {
      this.showSpinner = true;
    }

    this.bookmarkClick.emit();
  }

  reset() {
    this.isPaperBookmarked = false;
    this.showSpinner = false;
  }
}
